/**
 * The initial/default values the options vuex store uses for 0ptions
 */
export default function() {
    return {
        searchType: 'Used Cars',
        model: [],
        trim: [],
        manufacturer: [],
        minPrice: null,
        maxPrice: null,
        count: 0,
    };
}